// extracted by mini-css-extract-plugin
export default {"wrapper":"SlateEditor_wrapper__vXFA3","editable":"SlateEditor_editable__Bpv5h","focused":"SlateEditor_focused__1Giv+"};